// src/api/pistonApi.js
// export async function executeCode(language, code) {
//     const response = await fetch("http://localhost:2000/api/v2/execute", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         language,
//         version: "*", 
//         files: [{ name: "main", content: code }],
//         stdin: "",
//         args: [],
//       }),
//     });
  
//     if (!response.ok) {
//       throw new Error("Error executing code.");
//     }
  
//     return response.json();
//   }
  



// src/api/pistonApi.js
export async function executeCode(language, code, stdin = "") {
  const res = await fetch("http://localhost:2000/api/v2/execute", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      language,
      version: "*",
      files: [
        {
          // name is optional, but adding an extension helps some runtimes
          name: language === "javascript" ? "main.js"
               : language === "python" ? "main.py"
               : "main",
          content: code,
        },
      ],
      stdin,
      args: [],
    }),
  });

  // read body once (so you can see errors)
  const text = await res.text();
  let data;
  try { data = JSON.parse(text); } catch { data = { raw: text }; }

  if (!res.ok) {
    throw new Error(`Piston ${res.status}: ${data.message || data.raw || "Unknown error"}`);
  }

  return data;
}
